export const languageToLocale = {
    en: "en-US",
    fr: "fr",
    es: "es",
    pt: "pt",
    cn_s: "zh-CN",
    cn_t: "zh-HK",
    ta: "ta",
};
//# sourceMappingURL=locale-models.js.map